import Navbar from './navbar';
import React, { lazy, Suspense } from 'react';
import "../exerciselogs.css";

const LazyDotLottie = lazy(() =>
  import('@lottiefiles/dotlottie-react').then(module => ({ default: module.DotLottieReact }))
);

const links = [
  { url: '/', image: '/images/home.webp', text: 'Home', active: window.location.pathname === '/' },
  { url: '/fit-g', image: '/images/genie.webp', text: 'Fit-G', active: window.location.pathname === '/fit-g' },
  { url: '/exerciselogs', image: '/images/exercise.webp', text: 'Exercise Logs', active: window.location.pathname === '/exerciselogs' },
  { url: '/calculators/bmi', image: '/images/calculator.webp', text: 'Fitness Calculators', active: window.location.pathname === '/calculators/bmi' },
];

const CustomLoader = () => {
  return (
    <div className="loading-div">
      <Navbar links={links} />
      <div className="loading-animation">
        <Suspense fallback={<div className="animation-placeholder" style={{ width: 120, height: 120 }} />}>
          <LazyDotLottie
            src="https://lottie.host/fa4ea27e-a81c-4b75-b17c-5e6851aa2e8a/ISDDZSVe77.lottie"
            loop
            autoplay
            className="animation"
          />
        </Suspense>
        <p>Loading <div className="loader">
          <li className="ball"></li>
          <li className="ball"></li>
          <li className="ball"></li>
        </div></p>
      </div>
    </div>
  );
};

export default CustomLoader;
